import Loader from 'Components/Common/Loader'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchCompeitionGroupThunk, fetchCompetitionReportShareIdThunk } from 'slices/competitionAnalysis/thunk'
import { setHeaderCompetitionGroup } from 'slices/ui/reducer'
import { AppDispatch, RootState } from 'store'
import "./style.scss";
import { Button, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap'
import userDummyImg from "../../assets/images/users/user-dummy-img.jpg"
import SocialAccountCreators from 'Components/social-account/SocialAccountCreators'
import SocialAccountCreatorsFilters from 'Components/social-account/SocialAccountCreators/Filters'
import SocialAccountContentFilters from 'Components/social-account/SocialAccountContent/Filters'
import SocialAccountContent from 'Components/social-account/SocialAccountContent'
import CompetitionGroupDashboard from 'Components/CompetitionAnalysis/CompetitionGroup/Dashboard'
import { copyToClipboard } from 'utils/helpers'

const CompetitionGroup = () => {
    const { competitionGroupId } = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const competitionGroup = useSelector((state: RootState) => state.competitionAnalysis.group[competitionGroupId!]?.data);
    const tiers = useSelector((state: RootState) => state.competitionAnalysis.group[competitionGroupId!]?.creator_follower_tiers);
    const loading = useSelector((state: RootState) => state.competitionAnalysis.loading);
    const [socialAccountId, setSocialAccountId] = useState<string | null>(null)
    const [initialLoading, setInitialLoading] = useState(true);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const reportShareId = useSelector((state: RootState) => state.competitionAnalysis.shares.data[competitionGroupId!]?.uuid);
    const generatingShareId = useSelector((state: RootState) => state.competitionAnalysis.shares.loading);
    const [campaignLinkCopied, setCampaignLinkCopied] = useState(false);

    useEffect(() => {
        if(competitionGroupId && shareModalOpen){
            dispatch(fetchCompetitionReportShareIdThunk({competitionGroupId}));
        }
    }, [competitionGroupId, shareModalOpen])
    

    const eligibleSocialAccounts = useMemo(() => {
        if (competitionGroup?.accounts) {
            return competitionGroup.accounts.map((a) => a.social_account);
        }
        return [];
    }, [competitionGroup])

    const selectedSocialAccount = useMemo(() => {
        return eligibleSocialAccounts.find((a) => a.uuid === socialAccountId);
    }, [eligibleSocialAccounts, socialAccountId])

    useEffect(() => {
        if (!socialAccountId && eligibleSocialAccounts.length > 0) {
            setSocialAccountId(eligibleSocialAccounts[0].uuid);
        }
    }, [eligibleSocialAccounts])

    useEffect(() => {
        if (competitionGroupId) {
            setInitialLoading(true);
            dispatch(fetchCompeitionGroupThunk({ competitionGroupId })).finally(() => setInitialLoading(false));
        }
    }, [competitionGroupId])

    useEffect(() => {
        if (competitionGroup) {
            dispatch(setHeaderCompetitionGroup({ competitionGroup }));
        }

        return () => {
            dispatch(setHeaderCompetitionGroup({ competitionGroup: null }))
        }
    }, [competitionGroup])

    const getTabId = useMemo(() => {
        const path = window.location.pathname;
        if (path.includes('/creators')) return 'creators';
        if (path.includes('/content')) return 'content';
        return 'dashboard';
    }, [window.location.pathname]);

    const shareURL = useMemo(() => {
        return process.env.REACT_APP_APP_URL + `/share/competitor/${reportShareId}`;
    }, [reportShareId])

    if (initialLoading) return <Loader />

    return (
        <>
         <div className="campaign-page pt-4">
            {/* <div className="pt-0 d-flex w-100 justify-content-between align-items-center">
                <div className="competition-group-accounts">
                    {
                        competitionGroup.accounts.map((account, i) => (
                            <span key={i} className={`competition-group-account`} style={{ borderColor: `${stringToColor(account.social_account.handle)}` }}>
                                {
                                    account?.social_account?.profile_picture_url ? (
                                        <img src={account?.social_account?.profile_picture_url} className="rounded-circle avatar-xxs" alt="" />
                                    ) : <img src={userDummyImg} className="rounded-circle avatar-xxs" alt="" />
                                }
                                {account.social_account.name}
                            </span>
                        ))
                    }
                </div>
            </div> */}
            <div className="d-flex justify-content-between align-items-center campaign-page-info flex-column flex-lg-row gap-2 gap-lg-0">
                <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary nav-justified campaign-nav w-100 w-lg-50">
                    <NavItem className='campaign-nav-item'>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={`campaign-nav-link ${getTabId === 'dashboard' && 'active-campaign-nav'} text-start`}
                            onClick={() => navigate(`/competitor/${competitionGroupId}/`)}
                        >
                            Dashboard
                        </NavLink>
                    </NavItem>
                    <NavItem className='campaign-nav-item'>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={`campaign-nav-link ${getTabId === 'creators' && 'active-campaign-nav'} text-start`}
                            onClick={() => navigate(`/competitor/${competitionGroupId}/creators`)}
                        >
                            Creators
                        </NavLink>
                    </NavItem>
                    <NavItem className='campaign-nav-item'>
                        <NavLink
                            style={{ cursor: "pointer" }}
                            className={`campaign-nav-link ${getTabId === 'content' && 'active-campaign-nav'} text-start`}
                            onClick={() => navigate(`/competitor/${competitionGroupId}/content`)}
                        >
                            Content
                        </NavLink>
                    </NavItem>
                </Nav>

                    <div className='d-flex align-items-center gap-3 justify-content-end'>
                        {
                            getTabId === 'dashboard' &&
                            <button onClick={() => setShareModalOpen(true)} className="btn btn-sm btn-soft-primary btn-border campaign-edit-btn w-auto">Share <i className="ri-share-forward-fill"></i></button>
                        }
                        {
                            getTabId === 'creators' && <SocialAccountCreatorsFilters />
                        }
                        {
                            getTabId === 'content' && <SocialAccountContentFilters />
                        }
                        {
                             ['creators', 'content'].includes(getTabId) &&

                        <UncontrolledDropdown className='sort-dropdown'>
                            <DropdownToggle tag={"button"} className='btn btn-white d-flex justify-content-between align-items-center w-100'>
                                <span className="d-flex align-items-center gap-1">
                                    {
                                        selectedSocialAccount?.profile_picture_url ? (
                                            <img src={selectedSocialAccount?.profile_picture_url} className="rounded-circle avatar-xxs" alt="" />
                                        ) : <img src={userDummyImg} className="rounded-circle avatar-xxs" alt="" />
                                    }
                                    @{selectedSocialAccount?.handle}
                                </span>
                                {
                                    (eligibleSocialAccounts).length > 0 &&
                                    <i className='mdi mdi-chevron-down fs-5' />
                                }
                            </DropdownToggle>
                            <DropdownMenu className='mt-1 p-0 w-100'>
                                {
                                    (competitionGroup.accounts ?? []).map((a) => a.social_account).map((socialAccount, i) => <DropdownItem key={i} onClick={() => setSocialAccountId(socialAccount.uuid)}>
                                        <span className="d-flex align-items-center gap-1">
                                            {
                                                socialAccount?.profile_picture_url ? (
                                                    <img src={socialAccount?.profile_picture_url} className="rounded-circle avatar-xxs" alt="" />
                                                ) : <img src={userDummyImg} className="rounded-circle avatar-xxs" alt="" />
                                            }
                                            @{socialAccount.handle}
                                        </span>
                                    </DropdownItem>)
                                }
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        }
                    </div>
            </div>
            <div className="campaign-page-content my-3">
                {
                    getTabId === 'dashboard' && competitionGroup &&
                    <CompetitionGroupDashboard competitionGroup={competitionGroup} tiers={tiers} />
                }
                {
                    getTabId === 'creators' && socialAccountId &&
                    <>
                        <SocialAccountCreators socialAccountId={socialAccountId} />
                    </>
                }
                {
                    getTabId === 'content' && socialAccountId &&
                    <>
                        <SocialAccountContent socialAccountId={socialAccountId} />
                    </>
                }
            </div>
        </div>
         <Modal centered isOpen={shareModalOpen} toggle={() => setShareModalOpen(false)}>
                <ModalHeader toggle={() => setShareModalOpen(false)} className="border-bottom py-2">
                    Share
                </ModalHeader>
                <ModalBody>
                    <p> Share this report link with others to let them explore it.</p>
                    <InputGroup>
                        <Input
                            disabled={true}
                            type="text"
                            id="campaign-link"
                            className="form-control"
                            value={generatingShareId ? 'Please wait...' : shareURL} />

                        <Button title="Copy to clipboard" className="theme-btn theme-btn-lg btn-gradient" style={{ marginLeft: '-5px', height: '38px' }} onClick={() => {
                            copyToClipboard(shareURL);
                            setCampaignLinkCopied(true);
                        }}>
                            {
                                campaignLinkCopied ? <i className="bx bx-check"></i> : <i className="bx bx-copy"></i>
                            }
                        </Button>

                    </InputGroup>
                </ModalBody>
                <ModalFooter className="border-top py-2">
                    <Button className="btn btn-gradient" onClick={() => setShareModalOpen(false)}>Close</Button>
                </ModalFooter>
            </Modal>
        </>
       

    )
}

export default CompetitionGroup
